export default __webpack_public_path__ + "static/media/forgot-pass-success.4a2f1be4.png";